import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FaqSection = ({ content, testId = 'faq-section' }) => {
  useEffect(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: content.items.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-faq-schema', testId);
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [content, testId]);

  return (
    <section data-testid={testId} className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-12"
        >
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-stone-500 mb-4">
            {content.label}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-navy tracking-tight">
            {content.title}
          </h2>
        </motion.div>
        <Accordion type="single" collapsible className="w-full">
          {content.items.map((item, index) => (
            <AccordionItem key={index} value={`faq-${index}`} className="border-stone-200">
              <AccordionTrigger
                data-testid={`${testId}-question-${index}`}
                className="text-left font-heading text-lg text-navy hover:no-underline py-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-stone-600 leading-relaxed text-base pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
